"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _LoaderModule = _interopRequireDefault(require("./Loader.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Loader = function Loader(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_LoaderModule["default"].loader, className)
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _LoaderModule["default"].dot
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: _LoaderModule["default"].dot
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: _LoaderModule["default"].dot
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: _LoaderModule["default"].dot
  }));
};

process.env.NODE_ENV !== "production" ? Loader.propTypes = {
  className: _propTypes["default"].string
} : void 0;
Loader.defaultProps = {
  className: ''
};
var _default = Loader;
exports["default"] = _default;